import React, { useState } from "react";

const SettingTab = ({ handleLayoutChange, selectedLayout,updateAgeVerificationTabData,ageVerificationTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [minimumAge, setMinimumAge] = useState(ageVerificationTabData.minimum_age);
    const [ageDropdownOpen, setAgeDropdownOpen] = useState(false);
    const [verificationMethod, setVerificationMethod] = useState(ageVerificationTabData.verification_method);
    const [verificationMethodDropdownOpen, setVerificationMethodDropdownOpen] = useState(false);
    const [dateFormat, setDateFormat] = useState(ageVerificationTabData.date_format);
    const [dateFormatDropdownOpen, setDateFormatDropdownOpen] = useState(false);
    const [rememberVisitorDays, setRememberVisitorDays] = useState(ageVerificationTabData.remember_visitor_days);
    const [rememberVisitorDaysDropdownOpen, setRememberVisitorDaysDropdownOpen] = useState(false);
    const [actionType, setActionType] = useState(ageVerificationTabData.action_type);
    const [actionMessage, setActionMessage] = useState(ageVerificationTabData.action_message);
    const [actionRedirectUrl, setActionRedirectUrl] = useState(ageVerificationTabData.action_redirect_url);
    const [displayOnPages, setDisplayOnPages] = useState(ageVerificationTabData.display_on_pages);
    const [hideOnPages, setHideOnPages] = useState(ageVerificationTabData.hide_on_pages);

    // Handlers Minimum Age Change
    const handleMinimumAgeChange = (age) => {
        setMinimumAge(age);
        updateAgeVerificationTabData("languminimum_ageage_type", age);
        setAgeDropdownOpen(false);
    };

    // Handlers Verification Method Change
    const handleVerificationMethodChange = (age) => {
        setVerificationMethod(age);
        updateAgeVerificationTabData("verification_method", age);
        setVerificationMethodDropdownOpen(false);
    };

    // Handlers Date Format Change
    const handleDateFormatChange = (format) => {
        setDateFormat(format);
        updateAgeVerificationTabData("date_format", format);
        setDateFormatDropdownOpen(false);
    };

    // Handlers Remember Visitor Days Change
    const handleRememberVisitorDaysChange = (days) => {
        setRememberVisitorDays(days);
        updateAgeVerificationTabData("remember_visitor_days", days);
        setRememberVisitorDaysDropdownOpen(false);
    };

    // Handlers Action Type Change
    const handleActionTypeChange = (event) => {
        const value = event.target.value;
        setActionType(value);
        updateAgeVerificationTabData("action_type", value);
    };

    // Handlers Action Message Change
    const handleActionMessageChange = (event) => {
        const value = event.target.value;
        setActionMessage(value);
        updateAgeVerificationTabData("action_message", value);
    };

    // Handlers Action Redirect Url Change
    const handleActionRedirectUrlChange = (event) => {
        const value = event.target.value;
        setActionRedirectUrl(value);
        updateAgeVerificationTabData("action_redirect_url", value);
    };
    
    // Handlers Display On Pages Change
    const handleDisplayOnPagesChange = (event) => {
        const value = event.target.value;
        setDisplayOnPages(value);
        updateAgeVerificationTabData("display_on_pages", value);
    };

    // Handlers Hide On Pages Change
    const handleHideOnPagesChange = (event) => {
        const value = event.target.value;
        setHideOnPages(value);
        updateAgeVerificationTabData("hide_on_pages", value);
    };
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="layout-box-all">
                        <div className="card h-100">
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Minimum Age</span>
                                    <div className="color-pikr-box" onClick={() => setAgeDropdownOpen(!ageDropdownOpen)}>
                                        <em>{minimumAge}</em>
                                        {ageDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {[18,21].map((age) => (
                                                    <li key={age} onClick={() => handleMinimumAgeChange(age)}>
                                                        {age}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Verification Method</span>
                            <div className="color-pikr-box" onClick={() => setVerificationMethodDropdownOpen(!verificationMethodDropdownOpen)}>
                                <em>{verificationMethod}</em>
                                {verificationMethodDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {['Date of Birth','Year of Birth','Yes/No Buttons'].map((method) => (
                                            <li key={method} onClick={() => handleVerificationMethodChange(method)}>
                                                {method}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Date Format</span>
                            <div className="color-pikr-box" onClick={() => setDateFormatDropdownOpen(!dateFormatDropdownOpen)}>
                                <em>{dateFormat}</em>
                                {dateFormatDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {['MM/DD/YYYY','Auto','DD/MM/YYYY'].map((format) => (
                                            <li key={format} onClick={() => handleDateFormatChange(format)}>
                                                {format}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("remember_visitor")}>Remember Visitor <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("underage_action")}>Underage Action <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("where_to_display")}>Where To Display <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "remember_visitor" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Remember Visitor</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Days</span>
                                <div className="color-pikr-box" onClick={() => setRememberVisitorDaysDropdownOpen(!rememberVisitorDaysDropdownOpen)}>
                                    <em>{rememberVisitorDays}</em>
                                    {rememberVisitorDaysDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {[0,1,3,5,7,10,15,20,25,30,35,40,45,50,60,70,80,90,100,150,200].map((days) => (
                                                <li key={days} onClick={() => handleRememberVisitorDaysChange(days)}>
                                                    {days}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            
            {activeSettingElementsTab === "underage_action" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Underage Action</span>
                        <div className="name-tile-row">Action</div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="action_type1" type="radio" name="action_type" value="Show_Message" onChange={handleActionTypeChange} checked={actionType === 'Show_Message'}  />
                                            <label for="action_type1">Show Message</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="action_type2" type="radio" name="action_type"  value="Redirect_URL" onChange={handleActionTypeChange} checked={actionType === 'Redirect_URL'}/>
                                            <label for="action_type2">Redirect to URL</label>
                                        </div>
                                    </li>
                                </ul>
                            </div> 
                            {ageVerificationTabData.action_type === "Show_Message" && (
                                <>
                                    <div className="name-tile-row px-2">Message</div>
                                    <div className="side-baar-box-header">
                                        <div className="box-header-row bubble-text pt-0">
                                            <textarea className="w-100" value={actionMessage} onChange={handleActionMessageChange} placeholder="Type Message..." defaultValue="You are not old enough to view this content"></textarea>
                                        </div>
                                    </div>
                                </>
                            )}
                            {ageVerificationTabData.action_type === "Redirect_URL" && (
                                <>
                                    <div className="side-baar-box-header">
                                        <div className="box-header-row bubble-text">
                                            <input type="text" value={actionRedirectUrl} onChange={handleActionRedirectUrlChange}  placeholder="Redirect Url" />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "where_to_display" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Visibility on Pages</span>
                        <div className="name-tile-row">Display On Pages</div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_on_pages1" type="radio" name="display_on_pages" value="Display_All_Pages" onChange={handleDisplayOnPagesChange} checked={displayOnPages === 'Display_All_Pages'}  />
                                            <label for="display_on_pages1">All Pages</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_on_pages2" type="radio" name="display_on_pages"  value="Display_On_Homepage" onChange={handleDisplayOnPagesChange} checked={displayOnPages === 'Display_On_Homepage'}/>
                                            <label for="display_on_pages2">Homepage</label>
                                        </div>
                                    </li>
                                </ul>
                            </div> 
                        </div>

                        <div className="name-tile-row">Hide On Pages</div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="hide_on_pages1" type="radio" name="hide_on_pages" value="None" onChange={handleHideOnPagesChange} checked={hideOnPages === 'None'}  />
                                            <label for="hide_on_pages1">None</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="hide_on_pages2" type="radio" name="hide_on_pages"  value="Hide_On_Homepage" onChange={handleHideOnPagesChange} checked={hideOnPages === 'Hide_On_Homepage'}/>
                                            <label for="hide_on_pages2">Homepage</label>
                                        </div>
                                    </li>
                                </ul>
                            </div> 
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;